import * as Integrations from '@sentry/integrations';
import * as Sentry from '@sentry/browser';
import {options} from './options';

export function setUpAlerting({configuration, application = null, connectedUser, vueInstance = null}) {
    /**
     * Example of configuration object :
     * {
     *     application: 'my-app-name',
     *     configuration: {
     *         dsn: 'a_valid_dsn_url',
     *     },
     *     connectedUser: {
     *        identityId: 'identity_id',
     *        accountId: 'account_id',
     *        email: 'email@email.com'
     *     }
     * }
     */
    if (!configuration || !configuration.dsn) {
        throw new Error('Invalid configuration, could not initialize alerting service, dsn option is required');
    }

    const environment = configuration.environment || 'missing-env';
    const app = application || 'missing-application-name';

    const config = {
        dsn: configuration.dsn,
        environment,
        ...options,
    };

    if (vueInstance !== null) {
        config.Vue = vueInstance;
        config.integrations = [
            new Integrations.ExtraErrorData(),
            new Integrations.Vue({
                Vue: vueInstance,
                attachProps: true,
                logErrors: true,
            }),
        ];
    }

    Sentry.init(config);

    Sentry.setUser(Object.assign({}, connectedUser || {}));

    Sentry.setTags({
        application: app,
        layer: 'client',
    });

    window.captureException = (err) => Sentry.captureException(err);

    return config;
}
